export default "__VITE_ASSET___YPWikca__"